import React from 'react';
import history from '@history';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'app/store/modalSlice';

const BackHandler = () => {
  const dispatch = useDispatch();

  const { modalLength } = useSelector((state) => ({
    modalLength: state.modal.length,
  }));

  React.useEffect(() => {
    // if user refresh the app when the modal or any persist UI component is open
    // check and clear URL
    // if user open the modal in new tab we must replace the URL without parameters
    const queryParameters = Object.entries(queryString.parse(history.location.search));
    if (queryParameters.length) {
      const persistComponentsParams = ['modal', 'calendar', 'openLightBox', 'openDialog'];
      if (window.history.length <= 2) {
        const params = queryParameters.filter(
          ([key]) => persistComponentsParams.indexOf(String(key)) === -1
        );
        history.replace(
          `${history.location.pathname}${
            params.length ? `?${queryString.stringify(Object.fromEntries(params))}` : ''
          }`
        );
      } else {
        queryParameters.forEach(([key, value]) => {
          if (persistComponentsParams.includes(key) && value) {
            for (let i = 0; i < +value; i += 1) {
              history.go(-1);
            }
          }
        });
      }
    }
  }, []);

  React.useEffect(() => {
    const unregister = history.listen(({ action, location }) => {
      if (action === 'POP') {
        // if (isDialogOpen && !queryString.parse(location.search).openDialog) {
        //   dispatch(closeAlertDialog());
        // } else if (isLightBoxOpen && !queryString.parse(location.search).openLightBox) {
        //   dispatch(closeLightBox());
        // } else
        if (modalLength) {
          const { modal } = queryString.parse(location.search);
          if (!modal || +modal < modalLength) {
            dispatch(closeModal());
          }
        }
      }
    });

    return () => unregister();
  }, [dispatch, modalLength]);

  return null;
};

export default React.memo(BackHandler);
